import { clearInputField, getQueryStringParameter } from '../../../helpers.js'

$(document).ready(() => {
  const $form = $('form#natural-profile-form');

  if ($form.length === 0 || getQueryStringParameter('id') !== 'enough_capital') {
    return;
  }

  const $enoughCapital = $('#enoughCapital input[type=radio]', $form);

  $enoughCapital.on('click', (inputElement) => {
    $form.submit();
  });
})
